export const ImportModelsByType = new Map<string, any>([
  ['cinema', 'CinemaImport'],
  ['cinema-new', 'CinemaImport'],
  ['contentCache', 'ContentCacheModel'],
  ['feed-rss-atom', 'FeedImport'],
  ['grindelwald-mountain-railway', 'PontresinaMountainRailwayImport'],
  ['grindelwald-opening-state', 'GrindelwaldOpeningStateImport'],
  ['guidle-events', 'GuidleImport'],
  ['ibex3-guest-map', 'IbexGuestmapImport'],
  ['ibex3', 'IbexImport'],
  ['json', 'JSONImport'],
  ['pontresina-mountain-railway-new', 'PontresinaMountainRailwayImport'],
  ['pontresina-mountain-railway-tweebie', 'PontresinaMountainRailwayImport'],
  ['pontresina-mountain-railway', 'PontresinaMountainRailwayImport'],
  ['sbb-daily-schedule', 'SbbImport'],
  ['zermatt-peaks', 'TemperatureImport'],
  ['ticker', 'TickerImport'],
  ['tweebie_meta_importer', 'TweebieMetaImport'],
  ['twitter', 'TwitterImport'],
  ['weather', 'WeatherImport'],
  ['custom_street_conditions', 'StreetConditionsImport'],
  ['xml', 'XMLImport']
]);
